import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getAssetsListAsyncAction = createAsyncAction(
	"GET_ASSETS_LIST_REQUEST",
	"GET_ASSETS_LIST_SUCCESS",
	"GET_ASSETS_LIST_FAILURE",
	"GET_ASSETS_LIST_CANCEL"
);

export const postAssetAsyncAction = createAsyncAction(
	"POST_ASSETS_CREATE_REQUEST",
	"POST_ASSETS_CREATE_SUCCESS",
	"POST_ASSETS_CREATE_FAILURE",
	"POST_ASSETS_CREATE_CANCEL"
);

export const updateAssetAsyncAction = createAsyncAction(
	"PUT_ASSETS_UPDATE_REQUEST",
	"PUT_ASSETS_UPDATE_SUCCESS",
	"PUT_ASSETS_UPDATE_FAILURE",
	"PUT_ASSETS_UPDATE_CANCEL"
);

export const resetAction = createAction("ASSETS_RESET_ACTIONS");
